// WhatsAppButton.js
import React from 'react';
import whatsapp from '../assets/imgs/whats-app-icon.webp';
import '../assets/Whatsapp.css';

const Whatsapp = () => {
    const phoneNumber = '919730020099'; // your number
    const message = encodeURIComponent(
        'Hello, I’m interested in Samriddhi Group’s property offerings. Looking for plots or villas at [your preferred location] — please guide me with the best options. My name is [Your Name].'
    );

    return (

        <div className='whatsapp-container'>

            <div className="whats-app">
                <a
                    href={`https://wa.me/${phoneNumber}?text=${message}`}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="whatsapp-button"
                >
                    <img src={whatsapp} loading="lazy" alt="WhatsApp" className="whatsapp-icon" />
                    <div className="whatsapp-text">
                        <strong>Whatsapp</strong> <br />
                        <span>click to chat</span>
                    </div>
                </a>

            </div>
        </div>




    );
};

export default Whatsapp;
